module.exports = __webpack_public_path__ + "assets/825f5c49c1350da280e843ee8010cca0.eot";